import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css';
import { quillEditor } from 'vue3-quill'
// import 'ckeditor5/build/ckeditor.css';

createApp(App).use(store).use(router).use(quillEditor).mount('#app')
